module.exports = {
    // 全局性事件
    GetFaceList : "GetFaceList"   // 头像框列表
    ,UpdateTitleList : "UpdateTitleList" // 称号列表更新
    ,GetTitleList : "GetTitleList"  // 称号列表获取
    ,UseTitle : "UseTitle" // 使用称号变化
    ,GetModelList : "GetModelList" // 获取形象
    ,UpdateModel : "UpdateModel" // 更新形象
    ,ActiveModel : "ActiveModel" // 激活形象
    ,DISPATCH_PLAYER_VO_EVENT:"DISPATCH_PLAYER_VO_EVENT"//其他人的面板数据
    ,OPEN_SRV_DAY:"OPEN_SRV_DAY"//开服天数
    ,WorshipOtherRole:"WorshipOtherRole"//膜拜其他玩家
    ,UPDATE_ROLE_ACTION_ASSETS : "UPDATE_ROLE_ACTION_ASSETS" //派发角色活动资产变化
    ,UPDATE_ROLE_ATTRIBUTE : "UPDATE_ROLE_ATTRIBUTE" //派发单个属性数据的变化
    ,ROLE_REPORTED_EVENT : "ROLE_REPORTED_EVENT" //举报事件
};